import { formatDate, formatRelativeTime } from "~/lib/date-formatter";

interface DateDisplayProps {
  timestamp: number;
  showRelative?: boolean;
  className?: string;
}

/**
 * A component to display dates in a consistent format
 * Can show either absolute dates or relative time ("2 days ago")
 */
export function DateDisplay({ timestamp, showRelative = false, className = "" }: DateDisplayProps) {
  if (!timestamp) {
    return <span className={className}>No date available</span>;
  }
  
  const formattedDate = formatDate(timestamp);
  const relativeTime = formatRelativeTime(timestamp);
  
  if (showRelative) {
    // For relative display, show the relative time with absolute date as tooltip
    return (
      <span className={className} title={formattedDate}>
        {relativeTime}
      </span>
    );
  }
  
  // For absolute display, show the formatted date with relative time as tooltip
  return (
    <span className={className} title={relativeTime}>
      {formattedDate}
    </span>
  );
} 